/**
 * These stylesheets should be kept as the first imports in order to avoid css
 * source ordering issues. All stylesheets within this app need to be able to
 * override using a single class name.
 */
import 'normalize.css';
import '@farmersdog/corgi-legacy/build/components.css';
import '@farmersdog/corgi-x/build/styles.css';
import './App.css';

import { useSetCouponCookie } from '@farmersdog/coupons';
import { refreshSession } from '@farmersdog/sessions';
import { useUserEngagementHandler } from '@farmersdog/utils';

import { usePageTracker } from './analytics/hooks/usePageTracker';
import { FullFooter, Navigation, Page } from './components';
import { ErrorBoundary } from './components/ErrorBoundary';
import { useScrollRestore } from './hooks';
import { StaticRoutes } from './static-context';

export function App() {
  useUserEngagementHandler({ onUserEngagement: refreshSession });
  useSetCouponCookie();
  usePageTracker();
  useScrollRestore();

  return (
    <>
      <Navigation />
      <ErrorBoundary>
        <StaticRoutes page={Page} />
      </ErrorBoundary>
      <FullFooter />
    </>
  );
}
